<template>
    <div class="contenedor-principal-mapa">
        <div :id="idMapa" class="mapa"></div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import * as esri_geo from 'esri-leaflet-geocoder';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
   iconUrl: require('leaflet/dist/images/marker-icon.png'),
   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
    props: {
        idMapa: String,
        posicionOrigenMapa: Array,
        acercamientoInicialMapa: Number
    },
    data() {
        return {
            map: null,
            geocodeService: null,
            cursorDeMarcador: false,
            CoordenadasPuntoSeleccionado: null,
            geocodeSearch: null,
            datosBusquedaMarcador: null,
            posicionMapa: null,
            acercamientoMapa: null,
            marcadorSeleccionado: null
        }
    },
    methods: {
        setViewMapa: function(posicion, acercamiento) {
            if(this.map) {
                this.map.remove();
            }
            this.map = L.map(this.idMapa).setView(posicion, acercamiento);
            this.map.on('click', (e)=> { 
                this.CoordenadasPuntoSeleccionado = e.latlng; 
                if(this.cursorDeMarcador) {
                    this.obtenerDatosConMarcador()
                }
            });
            L.tileLayer(enumeraciones.sinoj.mapas.google.googleStreets,{ maxZoom: 20, subdomains:['mt0','mt1','mt2','mt3']}).addTo(this.map)
        },
        seleccionarDomicilio: function() {
            //console.log('entro a metodo seleccionar');
            if(!this.cursorDeMarcador) {
                L.DomUtil.addClass(this.map._container, 'crosshair-cursor-enabled');
                this.cursorDeMarcador = true;
            }
            else {
                L.DomUtil.removeClass(this.map._container, 'crosshair-cursor-enabled');
                this.cursorDeMarcador = false;
            }
        },
        obtenerDatosConMarcador: function() {
            //console.log('entro::geocodificar');
            this.eliminarMarcador();
            this.geocodeService.latlng(this.CoordenadasPuntoSeleccionado).run( (error, result) => {
                if (error) {
                    console.log(error);
                    return;
                }
                this.marcadorSeleccionado = L.marker(result.latlng);
                this.marcadorSeleccionado.addTo(this.map).bindPopup(result.address.Match_addr).openPopup();
                this.datosBusquedaMarcador = result;
                this.$emit('cambioDeDatosDomicilioMarcador', this.datosBusquedaMarcador);
            });
        },
        obtenerCoordenadasPorCalleParametros: function(datosDeDireccion) {
            //console.log('obtenerCoordenadasPorCalle::',datosDeDireccion);
            this.eliminarMarcador();
            this.geocodeSearch.address(datosDeDireccion.calle).city(datosDeDireccion.ciudad).region(datosDeDireccion.region).postal(datosDeDireccion.codigoPostal).run( (err, results, response) => {
                if (err) {
                    console.log(err);
                    return;
                }
                if(results.results.length > 0) {
                    let posicion     = [results.results[0].latlng.lat, results.results[0].latlng.lng];
                    let acercamiento = 19;
                    this.setViewMapa(posicion, acercamiento);
                    this.marcadorSeleccionado = L.marker(result.latlng);
                    this.marcadorSeleccionado.addTo(this.map).bindPopup(results.results[0].text).openPopup();
                }
                console.log(results);
            });
        },
        obtenerCoordenadasPorCalleCompleta: function(calleCompleta) {
            console.log('obtenerCoordenadasPorCalleCompleta::' + calleCompleta);
            this.eliminarMarcador();
            this.geocodeSearch.text(calleCompleta).run( (err, results, response) => {
                if (err) {
                    console.log(err);
                    return;
                }
                if(results.results.length > 0) {
                    let posicion     = [results.results[0].latlng.lat, results.results[0].latlng.lng];
                    let acercamiento = 19;
                    this.setViewMapa(posicion, acercamiento);
                    this.marcadorSeleccionado = L.marker(results.results[0].latlng);
                    this.marcadorSeleccionado.addTo(this.map).bindPopup(results.results[0].text).openPopup();
                }
                this.$emit('cambioDeDatosDomicilioTexto', results.results[0]);
            }); 
        },
        eliminarMarcador: function() {
            if(this.marcadorSeleccionado != null) {
                this.map.removeLayer(this.marcadorSeleccionado);
            }
        }
    },
    mounted() {     
        this.map = L.map(this.idMapa).setView(this.posicionOrigenMapa, this.acercamientoInicialMapa);
        this.map.on('click', (e)=> { 
            this.CoordenadasPuntoSeleccionado = e.latlng; 
            if(this.cursorDeMarcador) {
                this.obtenerDatosConMarcador()
            }
        });
        L.tileLayer(enumeraciones.sinoj.mapas.google.googleStreets,{ maxZoom: 20, subdomains:['mt0','mt1','mt2','mt3']}).addTo(this.map)
        this.geocodeService = esri_geo.reverseGeocode(); 
        this.geocodeSearch  = esri_geo.geocode();     
    }
}
</script>
<style scoped>
    .mapa {
        width: 100%;
        height: 100%;
        border: 3px solid #000;
    }

    .contenedor-principal-mapa {
        width: 100%;
        height: 100%;
    }

    .leaflet-container.crosshair-cursor-enabled {
        cursor: crosshair;
    }
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Comun/CMapaDeDomicilios.vue